import { render, staticRenderFns } from "./index非vant组件.vue?vue&type=template&id=5d47ee02&scoped=true"
import script from "./index非vant组件.vue?vue&type=script&lang=js"
export * from "./index非vant组件.vue?vue&type=script&lang=js"
import style0 from "./index非vant组件.vue?vue&type=style&index=0&id=5d47ee02&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d47ee02",
  null
  
)

export default component.exports